module.exports = __webpack_public_path__ + "static/media/YB5F13_5.f5539588.jpg";